import './styles/manuals.scss';

import ApplianceDocuments from '../components/appliance/ApplianceDocuments';
import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import GatsbyImageWrapper from '../components/GatsbyImageWrapper';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import { popFrontURL } from '../utils';
import rightArrowIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Right-Arrow-Icon-White.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query Manuals($code: String!) {
        productsJson(code: { eq: $code }) {
            code
            id
            documents {
                en_CA
                en_US
                fr_CA
                caption {
                    en_CA
                    en_US
                    fr_CA
                }
            }
            slug {
                en_CA
                en_US
                fr_CA
            }
            images {
                en_CA
                en_US
                fr_CA
            }
            fields {
                ...productsFieldsImagesFragment
            }
            category_localized {
                en_CA
                en_US
                fr_CA
            }
            title {
                en_CA
                en_US
                fr_CA
            }
        }
    }
`;

export default function Manuals({ data }: { data: Queries.ManualQuery }) {
    const product = data.productsJson;
    const { t } = useTranslation('layout');
    const { currentLocale } = usePageLocalization();

    const serialNumberFrom =
        product.attributes?.serial_number_from?.values[0]['en_CA'];
    const serialNumberTo =
        product.attributes?.serial_number_to?.values[0]['en_CA'];

    return (
        <Layout>
            <SEO
                title={t('metadata:manuals.title', {
                    SKU: product?.code,
                })}
                description={
                    t('metadata:manuals.description', {
                        SKU: product?.code,
                    }) as string
                }
            />

            <div className='container manuals'>
                <div className='manuals-banner-wrapper'>
                    {product?.fields?.images?.[0] && (
                        <GatsbyImageWrapper
                            className='product-image'
                            fields={product.fields}
                        />
                    )}
                    <div className='product-info'>
                        <span className='code'>{product?.code}</span>
                        <h1 className='title'>
                            {product?.title?.[currentLocale]}
                        </h1>
                        <span className='serial'>
                            {serialNumberFrom && serialNumberTo
                                ? t('parts.serial-fromto', {
                                      from: serialNumberFrom,
                                      to: serialNumberTo,
                                  })
                                : serialNumberFrom === undefined
                                  ? '--'
                                  : serialNumberFrom + t('parts.serial-from')}
                        </span>
                    </div>

                    {!product.slug['en_CA'].includes('discontinued') && (
                        // On affiche le boutton seulement si le produit n'est pas discontinué
                        <div className='button-container'>
                            <Button
                                className='englander-button'
                                label={t('parts.view-product') as string}
                                link={popFrontURL(
                                    product.slug[currentLocale],
                                    2
                                )}
                                iconRight={rightArrowIcon}
                            />
                        </div>
                    )}
                </div>

                <ApplianceDocuments
                    documents={product?.documents}
                    code={product?.code}
                    vuesIPEP={product?.fields?.vuesIPEP}
                    displayIPEP={false}
                    scrollManuals={false}
                />
            </div>
        </Layout>
    );
}
